import React from 'react';
import { Row, Col, Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const HomePage = ({ services, onSelectService }) => {
  return (
    <div>
      <Title level={2} style={{ textAlign: 'center', margin: '20px 0 40px' }}>
        Welcome to Yofi Service Center
      </Title>
      <Row gutter={[16, 16]} justify="center">
        {services.map(service => (
          <Col xs={24} sm={12} md={8} key={service.id}>
            <Card 
              title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div className="service-logo">
                    <img src={service.logo} alt={service.name} style={{ width: '100%', height: '100%' }} />
                  </div>
                  {service.name}
                </div>
              }
              className="service-card"
              onClick={() => service.available && onSelectService(service)}
              style={{ opacity: service.available ? 1 : 0.7 }}
            >
              <Paragraph>{service.description}</Paragraph>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default HomePage; 